import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Button, Box, Drawer } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useApiGet } from 'src/utils/api/general-service';

import UserInfo from './UserInfo';

const Header = () => {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // Fetch user profile data
  const { data: profileData } = useApiGet({
    endpoint: `/current-user`,
    queryKey: ['current-user'],
    config: {
      select: (data) => data?.data?.user,
    },
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    { label: 'Home', href: 'https://user.fly-inn.com/', target: '_blank' },
    { label: 'Map', href: `https://user.fly-inn.com`, target: '_blank' },

    { label: 'Stays', href: `https://user.fly-inn.com/listing`, target: '_blank' },
    { label: 'Contact', href: `https://user.fly-inn.com/contact`, target: '_blank' },
  ];

  return (
    <AppBar position="fixed" color="default" elevation={2}>
      <Toolbar className="flex justify-between">
        {/* Logo */}
        <Box
          alignItems="center"
          className="py-2.5  hidden md:flex cursor-pointer"
          onClick={() => {
            navigate('/dashboard/home');
          }}
        >
          <img src="/logo/favicon.svg" alt="Logo" className="w-auto h-20" />
        </Box>

        {/* Main Menu */}
        <Box display="flex" alignItems="center" className="hidden md:flex">
          {menuItems.map((item, index) => (
            <Button
              key={index}
              href={item.href}
              target={item.target || '_self'}
              rel="noreferrer"
              color="inherit"
              className="text-sm font-bold  hover:text-red-600"
            >
              {item.label}
            </Button>
          ))}
          <Button variant="contained">
            <a target="_blank" href="https://user.fly-inn.com/login" rel="noreferrer">
              Become a host
            </a>
          </Button>
        </Box>

        {/* Mobile Menu Button */}
        <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleMenuOpen} className="md:hidden">
          <MenuIcon />
        </IconButton>
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={() => {
            setIsDrawerOpen(true);
          }}
          className="md:hidden"
        >
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="left"
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(!isDrawerOpen);
          }}
        >
          <h1>test</h1>
        </Drawer>

        {/* User Info */}
        <UserInfo profileData={profileData} />
      </Toolbar>

      {/* Mobile Menu */}
      <Menu anchorEl={anchorEl} keepMounted open={isMenuOpen} onClose={handleMenuClose}>
        {menuItems.map((item, index) => (
          <MenuItem key={index} onClick={handleMenuClose}>
            <a href={item.href} target={item.target || '_self'} rel="noreferrer" className="hover:text-red-600">
              {item.label}
            </a>
          </MenuItem>
        ))}
      </Menu>
    </AppBar>
  );
};

export default Header;
